import React from 'react'
import ShipContent from './ShipContent'
import ShipSearch from './ShipSearch'
import Loading from '../../components/Loading/Loading'
import apiBarcode from '../../services/api/apiBarcode'
import PubSub from 'pubsub-js'
import { pushNewItemHistory } from "../../services/api/apiItemHistory"
import uniqueArray from "../helpers/uniqueArray"
import checkSameNumber from "../helpers/checkSameNumber"
import ableToPrint from "../../components/AbleToPrint/ableToPrint"
import { generateLabelShip } from "../../services/api/apiNextBarcode"
import { listTypeForce } from "./listTypeForce"
import { Spin } from 'antd'
import checkSameNumberCombine from '../helpers/checkSameNumberCombine'
import parseBarcodeNumber from '../helpers/parseBarcodeNumber'

const STORAGE_KEY = 'ShipPageState_v1'
const PENDING_KEY = `${STORAGE_KEY}_PENDING`

class ShipPage extends React.Component {
    state = {
        barcodeNumber: '',
        item: null,
        isLoading: false,
        isShowSearch: true,
        barcodeNumbers: [],
        mustGenLabel: false,
        isLoadingPrint: false,
        savedStatus: null, // lưu status nếu restore từ localStorage
        _hasAutoSubmitted: false
    }

    componentDidMount() {
        PubSub.subscribe('FOCUS_INPUT_SEARCH', this._showSearch)
        this._restoreState()
        window.addEventListener('beforeunload', this._saveState)
    }

    componentWillUnmount() {
        try { PubSub.unsubscribe('FOCUS_INPUT_SEARCH') } catch (e) { }
        window.removeEventListener('beforeunload', this._saveState)
    }

    // Chỉ lưu trạng thái với đơn gộp (Ko áp dụng với cả dơn thường)
    _shouldPersistState = () => {
        const { savedStatus, item } = this.state
        if (savedStatus && savedStatus.hasCombineShipTag) return true
        if (item && item.tags) {
            const hasCombineShipTag = item.tags.some(i => /^combine-ship(-\w+)?$/.test(i))
            if (hasCombineShipTag) return true
        }
        return false
    }

    _saveState = () => {
        try {
            if (!this._shouldPersistState()) {
                try { localStorage.removeItem(PENDING_KEY) } catch (e) { console.log('localStorage Remove error:', e.message) }
                return
            }

            const { barcodeNumber, barcodeNumbers } = this.state

            const status = this._getStatusData()
            const payload = {
                barcodeNumber,
                barcodeNumbers,
                status: status ? {
                    current: status.current,
                    total: status.total,
                    force: status.force,
                    hasCombineShipTag: status.hasCombineShipTag,
                    hasComboFacTag: status.hasComboFacTag
                } : null,
                savedAt: new Date().toISOString()
            }

            localStorage.setItem(PENDING_KEY, JSON.stringify(payload))
        } catch (e) {
            console.error('Save shippage state error', e)
        }
    }

    // RESTORE only from pending key
    _restoreState = () => {
        try {
            const raw = localStorage.getItem(PENDING_KEY)
            if (!raw) return

            let parsed = null
            try { parsed = JSON.parse(raw) } catch (e) { parsed = null }
            if (!parsed) return

            // Xóa localstorage nếu không phải đơn gộp
            if (!(parsed.status && parsed.status.hasCombineShipTag)) {
                try { localStorage.removeItem(PENDING_KEY) } catch (e) {console.log('localStorage Remove error:', e.message)}
                return
            }

            this.setState({
                barcodeNumber: parsed.barcodeNumber || '',
                barcodeNumbers: parsed.barcodeNumbers || [],
                savedStatus: parsed.status || null
            }, () => {
                // auto-submit last scanned barcode (no history)
                if (parsed.barcodeNumber && !this.state._hasAutoSubmitted) {
                    this.setState({ _hasAutoSubmitted: true })
                    setTimeout(async () => {
                        try {
                            await this._handleSubmit(parsed.barcodeNumber, { fromRestore: true })
                        } catch (e) {
                            console.error('Auto submit after restore failed', e)
                        }
                    }, 150)
                }
            })
        } catch (e) {
            console.error('Restore shippage state error', e)
        }
    }

    _setStateAndSave = (newState, cb) => {
        this.setState(newState, () => {
            this._saveState()
            if (typeof cb === 'function') cb()
        })
    }

    _showSearch = () => {
        // clear item để ẩn preview label trên header khi hủy lệnh / quay lại tìm kiếm
        this._setStateAndSave({ isShowSearch: true, barcodeNumber: '', barcodeNumbers: [], savedStatus: null, item: null })
    }

    _handleChangeInput = (e) => {
        const { name, value } = e.target
        this._setStateAndSave({ [name]: value })
    }

    // Quy trình mới gen label từ FFM không đẩy note xuống FAC, nên đơn update address trên FFM
    // không bị chặn ở FAC. Request update address là request cho cả đơn (order-level), nên chỉ
    // check tag trên order. Cover cả lúc đang chờ update ('waiting-update-address') lẫn lúc đã
    // update xong nhưng chưa gen lại label ('updated-address'). Check tại bước dán label để chặn.
    _hasUpdateAddressRequest = (order) => {
        if (!order || !Array.isArray(order.tags)) return false

        const addressRequestTags = ['waiting-update-address', 'updated-address']
        return order.tags.some(tag => addressRequestTags.includes(tag))
    }

    // Các màn in/hiển thị label đều dựa vào labelDetails (partnerTrackingNumber / url / trackingNumber),
    // không dùng mảng labels. Nên coi là chưa có label khi labelDetails chưa có dữ liệu in được.
    _hasNoLabel = (order) => {
        if (!order) return true

        const {labelDetails} = order
        if (!(labelDetails instanceof Object)) return true

        const {partnerTrackingNumber, url, trackingNumber} = labelDetails
        return !partnerTrackingNumber && !url && !trackingNumber
    }

    _fetchItem = async (params = '', init = false, fromRestore = false) => {
        const { barcodeNumber } = this.state
        if (!barcodeNumber) return

        try {
            let newItem = null
            let newPartnerTrackingNumber = ''

            if (!barcodeNumber.startsWith('#')) throw new Error('Invalid ID.')

            const trimmedNumber = barcodeNumber.replace('#', '')
            const codes = trimmedNumber.split('_')
            const newParams = (params !== '') ? `${params}&item=${codes[1]}` : `item=${codes[1]}`
            const resRead = await apiBarcode.getBarcodeByNumber(codes[0], newParams)
            const { success, data, message } = resRead.data
            const { labelDetails, batch_ship } = { ...data }
            const { status: batchStatus, id: batchId } = { ...batch_ship }
            const { shipping_carrier } = { ...labelDetails }

            if (!success) throw Error(message)
            if (!data) throw new Error('No items found.')

            // Chặn dán label khi đơn đang request update address VÀ chưa có label
            if (this._hasUpdateAddressRequest(data) && this._hasNoLabel(data)) {
                throw new Error(`Đơn ${barcodeNumber} đang request update address và chưa có label!`)
            }

            if (shipping_carrier === 'SB_FAST') {
                if (!!batchStatus && batchStatus !== 'confirmed' && shipping_carrier === 'SB_FAST') {
                    throw new Error(`Lô ship ${batchId} cần confirmed trước khi dán label!`)
                }
                if (!batchStatus && shipping_carrier === 'SB_FAST') {
                    throw new Error('Đơn hàng SB_FAST phải được cho vào lô ship trước khi dán label!')
                }
            } else {
                if (data.order_type !== 'FBA') {
                    if (data.status === 'error' && data.labels.length === 0 && shipping_carrier !== 'SB_FAST') {
                        throw new Error('Lỗi không gen được Label, báo lại với team support')
                    }
                } else {
                    const { split_fba_item_label_status, split_fba_item_label } = data
                    if ((!split_fba_item_label_status || split_fba_item_label_status !== 'success' || !split_fba_item_label) && shipping_carrier !== 'SB_FAST') {
                        throw new Error('Lỗi tách label, báo lại với team support')
                    }
                }

                if (data.hasOwnProperty('_id')) {
                    if (data.must_generate_new_label !== undefined && data.must_generate_new_label && data.production_status !== 'packaged') {
                        newItem = await this._handleCheckGenAuto(data)
                        if (newItem === null) return false
                        const { labelDetails } = newItem
                        newPartnerTrackingNumber = labelDetails.partnerTrackingNumber
                    }
                }
            }

            // --- compute status (total/force/flags) from the fetched item data
            const computeStatusFromItem = (itemData, fallbackCurrent = 0) => {
                if (!itemData || typeof itemData !== 'object') return null
                const { products = [], order_type, tags = [], siblingsBarcodes = [] } = itemData
                const hasCombineShipTag = tags.some(i => /^combine-ship(-\w+)?$/.test(i))
                const hasComboFacTag = tags.includes('combo_fac')
                const total = hasCombineShipTag ? (siblingsBarcodes ? siblingsBarcodes.length + 1 : 1) : (products && products.length ? products.length : 0)

                const listType = products.map(product => product.type)
                const uniqueChars = [...new Set(listType)]
                let arrFilter = listType
                if (uniqueChars.length === 1) {
                    arrFilter = products.filter(product => {
                        const { type } = product
                        return !listTypeForce.includes(type)
                    })
                }
                const itemsFilter = arrFilter.length > 0 ? arrFilter.filter(itemFilter => itemFilter.type !== 'FILTER') : []
                const force = order_type === 'FBA' || !itemsFilter.length

                return {
                    current: fallbackCurrent,
                    total,
                    force,
                    hasCombineShipTag,
                    hasComboFacTag
                }
            }

            // Decide what to use as "current" (keep saved current if present; otherwise use barcodeNumbers length)
            const { barcodeNumbers = [], savedStatus: savedStatusInState } = this.state
            const fallbackCurrent = (savedStatusInState && typeof savedStatusInState.current === 'number')
                ? savedStatusInState.current
                : (Array.isArray(barcodeNumbers) ? barcodeNumbers.length : 0)

            // compute status from fresh data
            const freshStatus = computeStatusFromItem(data, fallbackCurrent)

            // If we already had a savedStatus, keep its current and only update total/flags/force
            const newSavedStatus = (savedStatusInState)
                ? Object.assign({}, savedStatusInState, {
                    total: freshStatus ? freshStatus.total : (savedStatusInState.total || 0),
                    force: freshStatus ? freshStatus.force : savedStatusInState.force,
                    hasCombineShipTag: freshStatus ? freshStatus.hasCombineShipTag : savedStatusInState.hasCombineShipTag,
                    hasComboFacTag: freshStatus ? freshStatus.hasComboFacTag : savedStatusInState.hasComboFacTag
                })
                : freshStatus

            // set item and persist — but keep savedStatus.current if existed
            this._setStateAndSave({ item: data, isLoading: false, savedStatus: newSavedStatus }, () => {
                if (!init) return

                // only push history when NOT from restore
                if (!fromRestore) {
                    const { labelDetails } = Object.assign({}, data)
                    const { partnerTrackingNumber } = Object.assign({}, labelDetails)

                    pushNewItemHistory(barcodeNumber, {
                        event_key: 'scan_to_label_standard',
                        event_description: 'Scan QR to label.',
                        event_meta: {
                            partnerTrackingNumber: newPartnerTrackingNumber ? newPartnerTrackingNumber : partnerTrackingNumber,
                        }
                    })
                }

                if (newItem !== null) {
                    // recompute status from newItem and update savedStatus.total similarly,
                    // but preserve current if it existed.
                    const freshStatusFromNewItem = computeStatusFromItem(newItem, fallbackCurrent)
                    const updatedSavedStatusForNewItem = (savedStatusInState)
                        ? Object.assign({}, savedStatusInState, {
                            total: freshStatusFromNewItem ? freshStatusFromNewItem.total : savedStatusInState.total,
                            force: freshStatusFromNewItem ? freshStatusFromNewItem.force : savedStatusInState.force,
                            hasCombineShipTag: freshStatusFromNewItem ? freshStatusFromNewItem.hasCombineShipTag : savedStatusInState.hasCombineShipTag,
                            hasComboFacTag: freshStatusFromNewItem ? freshStatusFromNewItem.hasComboFacTag : savedStatusInState.hasComboFacTag
                        })
                        : freshStatusFromNewItem

                    this._setStateAndSave({ item: newItem, savedStatus: updatedSavedStatusForNewItem })
                }
                return true
            })
        } catch (e) {
            alert(e.message)
            pushNewItemHistory(barcodeNumber, {
                event_key: 'scan_to_label_standard',
                event_description: 'Scan QR to label.',
            })
            this._setStateAndSave({
                isShowSearch: true,
                item: null,
                isLoading: false
            })
        }
    }

    _handleCheckGenAuto = async (order) => {
        this._setStateAndSave({ mustGenLabel: true })
        try {
            const payload = {
                status: order.gen_at !== undefined ? 'regenerated' : 'generated'
            }

            const { data, success, message } = await generateLabelShip(order._id, payload)
            if (!success) throw new Error(message)
            this._setStateAndSave({ mustGenLabel: false })
            return data
        } catch (e) {
            this._setStateAndSave({ mustGenLabel: false })
            alert(e.message)
            return null
        }
    }

    _checkIncludeCombine = (orders, barcode) => {
        const parsedBarcode = parseBarcodeNumber(barcode)
        const parsedOrders = orders.map(item => item.barcodeNumber)
        return parsedOrders.includes(parsedBarcode.number)
    }

    _changeBarcodeNumbersCombine = (barcodeNumbers, barcode) => {
        const parsedBarcode = parseBarcodeNumber(barcode)
        return barcodeNumbers.map(item => {
            const parsedItem = parseBarcodeNumber(item)
            return parsedItem.number === parsedBarcode.number ? barcode : item
        })
    }

    _getNewBarcodeNumbers = (barcode) => {
        const { barcodeNumbers, item } = this.state
        if (!barcodeNumbers.length) return [].concat(barcodeNumbers, [barcode])

        if (item && item.siblingsBarcodes) {
            const isSameCombine = checkSameNumberCombine(barcodeNumbers, barcode)
            if (isSameCombine) return this._changeBarcodeNumbersCombine(barcodeNumbers, barcode)
            const isIncludeCombine = this._checkIncludeCombine(item.siblingsBarcodes, barcode)
            if (!isIncludeCombine) return [barcode]
        } else {
            const isSame = checkSameNumber(barcodeNumbers[0], barcode)
            if (!isSame) return [barcode]
        }

        return uniqueArray([].concat(barcodeNumbers, [barcode]))
    }

    // _handleSubmit accepts options: { fromRestore: boolean }
    _handleSubmit = async (barcode, options = {}) => {
        const { fromRestore = false } = options

        this._setStateAndSave({
            isLoading: true,
            isShowSearch: false,
            barcodeNumber: barcode
        }, async () => {
            const able = await ableToPrint(barcode, 'print_label', () => {
                this._setStateAndSave({
                    barcodeNumber: '',
                    isLoading: false,
                    isShowSearch: true
                })
            })

            if (!able) {
                pushNewItemHistory(barcode, {
                    event_key: 'scan_to_label_standard',
                    event_description: 'Scan QR to label.',
                })
                return false
            }

            let vBarcodeNumbers
            if (fromRestore && Array.isArray(this.state.barcodeNumbers) && this.state.barcodeNumbers.length) {
                vBarcodeNumbers = this.state.barcodeNumbers
            } else {
                vBarcodeNumbers = this._getNewBarcodeNumbers(barcode)
            }

            this._setStateAndSave({
                barcodeNumbers: vBarcodeNumbers,
                savedStatus: fromRestore ? this.state.savedStatus : null
            }, async () => {
                await this._fetchItem('page=shipPage', true, fromRestore)
            })
        })
    }

    _renderLoading = () => {
        const { isLoading } = this.state
        if (isLoading) return <Loading />
    }

    _renderContent = () => {
        const { isLoading, item, barcodeNumber, barcodeNumbers } = this.state
        const data = this._getStatusData()
        if (!data) return ''
        const { current, total } = data

        if (!isLoading && item) {
            return <ShipContent
                item={item}
                total={total}
                current={current}
                barcodeNumber={barcodeNumber}
                reloadItem={this._fetchItem}
                ableToPrint={this._ableToPrintLabel}
                onLoadingPrint={this._handleChangeLoadingPrint}
                barcodeNumbers={barcodeNumbers}
                clearSavedState={this.clearSavedState}
            />
        }
    }

    _getStatusData = () => {
        const { barcodeNumbers, item, savedStatus } = this.state

        // nếu có savedStatus (restore từ localStorage) và có barcodeNumbers, trả về savedStatus
        if (savedStatus && barcodeNumbers && barcodeNumbers.length) {
            return savedStatus
        }

        if (!item || typeof item !== 'object') return false
        if (!barcodeNumbers || !barcodeNumbers.length) return false

        const { products, order_type, tags = [], siblingsBarcodes = [] } = item
        const hasCombineShipTag = tags.some(i => /^combine-ship(-\w+)?$/.test(i))
        const hasComboFacTag = tags.includes('combo_fac')

        const total = hasCombineShipTag ? siblingsBarcodes.length + 1 : (products && products.length) ? products.length : 0
        if (!total) return false

        const listType = products.map(product => product.type)
        const uniqueChars = [...new Set(listType)]
        let arrFilter = listType

        if (uniqueChars.length === 1) {
            arrFilter = products.filter(product => {
                const { type } = product
                return !listTypeForce.includes(type)
            })
        }

        const itemsFilter = arrFilter.length > 0 ? arrFilter.filter(itemFilter => itemFilter.type !== 'FILTER') : []
        const force = order_type === 'FBA' || !itemsFilter.length

        return {
            current: barcodeNumbers.length,
            total,
            force,
            hasCombineShipTag,
            hasComboFacTag
        }
    }

    _getStatus = () => {
        const data = this._getStatusData()
        if (!data) return ''
        const { current, total, hasCombineShipTag, hasComboFacTag } = data
        return (
            <>
                {current} / {total}
                {hasCombineShipTag && !hasComboFacTag &&
                    <div style={{ fontSize: '14px', color: 'red' }}>(Đơn gộp cần quét mỗi đơn 1 item.)</div>
                }
            </>
        )
    }

    _ableToPrintLabel = () => {
        const { item } = this.state
        if (!item) return false
        const { products, tags = [], country } = item
        if(country === "VN") return true

        const cancelItem = products.filter(product => product.status === "cancelled")
        const hasCombineShipTag = tags.some(i => /^combine-ship(-\w+)?$/.test(i))
        const data = this._getStatusData()
        if (!data) return false
        const { current, total, force } = data

        if (hasCombineShipTag) return (current + cancelItem.length) >= total
        if (force) return true
        return (current + cancelItem.length) >= total || current >= 5
    }

    _handleChangeLoadingPrint = (isLoadingPrint) => {
        this._setStateAndSave({ isLoadingPrint })
    }

    // clear only pending key
    clearSavedState = () => {
        try {
            localStorage.removeItem(PENDING_KEY)
        } catch (e) { console.log('Clear Error:', e) }
        return new Promise(resolve => {
            this.setState(
                { barcodeNumber: '', barcodeNumbers: [], item: null, savedStatus: null },
                resolve
            )
        })
    }


    render() {
        const { barcodeNumber, isShowSearch, item, mustGenLabel } = this.state
        return (
            <Spin tip='Printing...' spinning={this.state.isLoadingPrint}>
                <div className='ShipPage'>
                    <ShipSearch
                        item={item}
                        value={barcodeNumber}
                        status={this._getStatus()}
                        onSubmit={this._handleSubmit}
                    />

                    {(!isShowSearch && !mustGenLabel) && this._renderLoading()}
                    {(!isShowSearch && !mustGenLabel) && this._renderContent()}

                    {mustGenLabel && (
                        <div className="text-center">Label này đã qua 13 ngày chưa được generate, hệ thống đang generate
                            label trước khi in <i className="fa fa-spinner fa-spin" /></div>
                    )}
                </div>
            </Spin>
        )
    }
}

export default ShipPage
